import { atom } from 'recoil';

export const useCalendarIndex = atom({
  key: 'useCalendarIndex',
  default: true,
});
